// Swish logo SVG with transparent background — works on any surface
export default function SwishLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 420 420" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sw-lg1" x1="-746" x2="-746.2" y1="822.6" y2="823.1" gradientTransform="matrix(300.3 0 0 -370.5 224261 305063)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ef2131" />
          <stop offset="1" stopColor="#fecf2c" />
        </linearGradient>
        <linearGradient id="sw-lg2" x1="-745.4" x2="-745.9" y1="823" y2="822.1" gradientTransform="matrix(273.8 0 0 -300.2 204470 247194)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fbc52c" />
          <stop offset=".3" stopColor="#f87130" />
          <stop offset=".6" stopColor="#ef52e2" />
          <stop offset="1" stopColor="#661eec" />
        </linearGradient>
        <linearGradient id="sw-lg3" x1="-746" x2="-745.8" y1="823" y2="822.5" gradientTransform="matrix(300.3 0 0 -370.5 224142 305014)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#78f6d8" />
          <stop offset=".3" stopColor="#77d1f6" />
          <stop offset=".6" stopColor="#70a4f3" />
          <stop offset="1" stopColor="#661eec" />
        </linearGradient>
        <linearGradient id="sw-lg4" x1="-746.1" x2="-745.6" y1="822.3" y2="823.2" gradientTransform="matrix(273.8 0 0 -300.2 204377 247074)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#536eed" />
          <stop offset=".2" stopColor="#54c3ec" />
          <stop offset=".6" stopColor="#64d769" />
          <stop offset="1" stopColor="#fecf2c" />
        </linearGradient>
      </defs>
      <path fill="url(#sw-lg1)" d="M119.3,399.2c84.3,40.3,188.3,20.4,251.2-54.5,74.5-88.8,62.9-221.1-25.8-295.5l-59,70.3c69.3,58.2,78.4,161.5,20.2,230.9-46.4,55.3-122.8,73.7-186.5,48.9" />
      <path
        fill="url(#sw-lg2)"
        d="M119.3,399.2c84.3,40.3,188.3,20.4,251.2-54.5,7.7-9.2,14.5-18.8,20.3-28.8,9.9-61.7-11.9-126.9-63.2-169.9-13-10.9-27.2-19.8-41.9-26.5,69.3,58.2,78.4,161.5,20.2,230.9-46.4,55.3-122.8,73.7-186.5,48.9"
      />
      <path fill="url(#sw-lg3)" d="M300.3,20.4C216-19.9,111.9,0,49.1,74.9c-74.5,88.8-62.9,221.1,25.8,295.5l59-70.3c-69.3-58.2-78.4-161.5-20.2-230.9C160.2,14,236.6-4.5,300.3,20.4" />
      <path
        fill="url(#sw-lg4)"
        d="M300.3,20.4C216-19.9,111.9,0,49.1,74.9c-7.7,9.2-14.5,18.8-20.3,28.8-9.9,61.7,11.9,126.9,63.2,169.9,13,10.9,27.2,19.8,41.9,26.5-69.3-58.2-78.4-161.5-20.2-230.9C160.2,14,236.6-4.5,300.3,20.4"
      />
    </svg>
  )
}
